import React from "react";
import { destroyAsset, uploadAsset } from "src/actions/mine_craft/assetsActions";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { setNewGroupParams } from "src/store/mine_craft/assetsSlice";

import DrawerRight from "src/componets/DrawerRight";
import GroupUpload from "src/componets/FileDropzone/GroupUpload";
import mineCraftApi from "src/api/mineCraftApi";
import { message } from "antd";

const Dropzone = () => {
  const dispatch = useAppDispatch();
  const newGroupParams = useAppSelector(state => state.mineCraft.assets.newGroupParams);
  // TODO: Implement dynamic type_id
  //  Stub type_id to avatar
  const data: any = { app_id: newGroupParams?.app_id, type_id: 1 };

  function onClose() {
    dispatch(setNewGroupParams(null));
  }

  function handleUploadSuccess(response: any) {
    dispatch(uploadAsset(response));
  }

  function onClickDestroy(file: any) {
    const id = file.response?.asset?.id;
    if (id) {
      handleDestroy(id).catch(console.error);
    }
  }

  async function handleDestroy (id: any) {
    const resultAction = await dispatch(destroyAsset(id));

    if (destroyAsset.fulfilled.match(resultAction)) {
      message.success(`ItemID ${id} was successful deleted`);
    }

    if (destroyAsset.rejected.match(resultAction)) {
      message.error(resultAction.error.message);
    }
  }

  return (
    <DrawerRight
      open={!!newGroupParams}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-newGroup-asset'>
        <h6 className="v-content-label">Avatars Dropzone</h6>

        <GroupUpload
          name='image'
          action={mineCraftApi.oneSky.url('/onesky/assets')}
          headers={mineCraftApi.oneSky.uploadHeaders}
          data={data}
          onSuccess={handleUploadSuccess}
          listType='picture'
          onRemove={onClickDestroy}
        />
      </div>
    </DrawerRight>
  )
}

export default Dropzone;
